export enum ProductRecommendationTypes {
  Recommended = "Recommended",
  Alternative = "Alternative",
  NotRecommended = "NotRecommended",
  Retain = "Retain",
  Replace = "Replace",
  Custom = "Custom",
}
